import React, { useState } from 'react';
import { Brand } from '../types/BookingTypes';
import { useNavigate } from 'react-router-dom';

interface BrandSelectorProps {
  brands: Brand[];
  selectedBrand: Brand | null;
}

const INITIAL_COUNT = 12;

const BrandSelector: React.FC<BrandSelectorProps> = ({ brands, selectedBrand }) => {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);

  const visibleBrands = showAll ? brands : brands.slice(0, INITIAL_COUNT);

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-1 h-5 bg-minto-500 rounded-full" />
          <h3 className="text-base md:text-lg font-semibold text-gray-900">Select Your Brand</h3>
        </div>
      </div>
      <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-3">
        <div className="grid grid-cols-4 gap-2">
          {visibleBrands.map((brand) => (
            <button
              key={brand.id}
              className={`flex flex-col items-center justify-center py-3 px-1 rounded-md transition-all duration-200 ${
                selectedBrand?.id === brand.id 
                  ? 'bg-minto-50 ring-2 ring-minto-500' 
                  : 'hover:bg-gray-50 active:scale-95'
              }`}
              onClick={() => navigate(`/brand/${brand.id}`)}
            >
              <div className="w-8 h-8 mb-1.5 flex items-center justify-center">
                <img 
                  src={brand.logo} 
                  alt={brand.name} 
                  className="w-full h-full object-contain" 
                />
              </div>
              <span className="text-[10px] font-medium text-gray-700 text-center leading-tight line-clamp-1">{brand.name}</span>
            </button>
          ))}
        </div>

        {/* View All */}
        {brands.length > INITIAL_COUNT && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="w-full mt-2 pt-2 border-t border-gray-100 text-xs font-medium text-minto-600 hover:text-minto-700 flex items-center justify-center gap-1"
          >
            {showAll ? (
              <>Show Less <i className="fas fa-chevron-up text-[10px]"></i></>
            ) : (
              <>View All {brands.length} Brands <i className="fas fa-chevron-down text-[10px]"></i></>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default BrandSelector;
